import {create} from 'zustand'

const useDownloadStore = create((set) => ({
    state: {
        progress: 0,
        downloadSpeed: 0,
        queue: [],
        currentFile: null,
    },
    actions : {
        addFileToQueue: (file) => set(store => ( {...store, state:{...store.state, queue: [...store.state.queue, file]}})),
        removeFileFromQueue: (file) => set(store => ( {...store, state:{...store.state, queue: store.state.queue.filter(f => f !== file)}})),
        setCurrentFile: (file) => set(store => ( {...store, state:{...store.state, currentFile: file}})),
        setProgress: (progress) => set(store => ( {...store, state:{...store.state, progress: progress}})),
        setDownloadSpeed: (speed) => set(store => ( {...store, state:{...store.state, downloadSpeed: speed}})),
    }
}))

export default useDownloadStore;
